// Kept apart from the sorted imports below to preserve CSS cascade order.
import './playlist-player.scss';

import 'Video/components/vm-video-card-related/vm-video-card-related';
import 'Video/components/vm-video-hub-card/vm-video-hub-card';
import 'Video/components/vm-video-hub-related/vm-video-hub-related';
import 'Video/components/vm-video-related-content/vm-video-related-content';
import { trackPlaylistItemClicks } from './playlist-tracking';

trackPlaylistItemClicks();
